import { DialogActions } from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import CustomDialog from 'shared/components/CustomDialog'

interface Props {
   open: boolean
   onClose: () => void
   onSubmit: () => void
}

export default function UnsavedChangesModal({ open, onClose, onSubmit }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'CUSTOMERS'])

   return (
      <CustomDialog
         open={open}
         onClose={onClose}
         isLoading={!open}
         deleteVariant
         content={
            <>
               <DialogTitle>{t('CUSTOMERS:unsavedChangesModal.title')}</DialogTitle>
               <DialogActions>
                  <OutlinedButton isDelete variant="outlined" onClick={onClose}>
                     {t('TRANSLATION:back')}
                  </OutlinedButton>
                  <ContainedButton isDelete variant="contained" onClick={onSubmit}>
                     {t('TRANSLATION:yes')}
                  </ContainedButton>
               </DialogActions>
            </>
         }
      />
   )
}
